import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from '../card/Card.jsx';
import CardActions from '../card/CardActions.jsx';
import CardContent from '../card/CardContent.jsx';
import ProviderHeader from '../provider/ProviderHeader.jsx';
import styles from '../../styles/styles';

const VisitCard = (props) => {
  const {
    providerName,
    providerLoading,
    providerSpecialty,
    providerAvatarUrl,
    content,
    actions,
    cardTestId,
    titleTestId,
    nameTestId,
    specialtyTestId,
    visitType,
    scheduledType,
  } = props;

  const classes = useStyles(props);

  const renderHeader = () => {
    if (!providerName && scheduledType !== 'now') return null;
    return (
      <ProviderHeader
        nameTestId={nameTestId}
        specialtyTestId={specialtyTestId}
        name={providerName}
        loading={providerLoading}
        specialty={providerSpecialty}
        avatarUrl={providerAvatarUrl}
        visitType={visitType}
        scheduledType={scheduledType}
        titleTestId={titleTestId}/>
    );
  };

  const renderActions = () => {
    if (!actions) return null;
    return (
      <CardActions
        className={classNames(classes.cardActions, props.actionsClass)}>
        {actions}
      </CardActions>
    );
  };

  return (
    <Card
      className={classNames(classes.card, props.className)}
      data-testid={cardTestId}>
      <CardContent
        className={classNames(classes.cardContent, props.contentClass)}>
        { renderHeader() }
        { content }
      </CardContent>
      { renderActions() }
    </Card>
  );
};

VisitCard.propTypes = {
  providerName: PropTypes.string,
  providerLoading: PropTypes.bool,
  providerSpecialty: PropTypes.string,
  providerAvatarUrl: PropTypes.string,
  content: PropTypes.node,
  actions: PropTypes.node,
  actionsClass: PropTypes.string,
  contentClass: PropTypes.string,
  className: PropTypes.string,
  cardTestId: PropTypes.string,
  titleTestId: PropTypes.string,
  nameTestId: PropTypes.string,
  specialtyTestId: PropTypes.string,
  visitType: PropTypes.string,
  scheduledType: PropTypes.string,
};


const useStyles = styles.makeStyles(
    (theme) => {
      return {
        card: {
          borderRadius: 16,
          boxShadow: '0px 12px 24px rgba(32, 69, 102, 0.2)',
        },
        cardContent: ({scheduledType}) => ({
          backgroundColor: scheduledType === 'now' ? '#204565' : '#006F84',
          padding: 24,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        }),
        cardActions: {
          paddingTop: 0,
        },
      };
    },
);

export default VisitCard;
